import { makeStyles } from '@mui/styles';

const useSiteHeaderStyle = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  home: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10,
    zIndex: 2,
    fontFamily: 'Lato !important',
  },
  themeToggle: {
    cursor: 'pointer',
    color: '#8CB4FF',
  },
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    columnGap: 20,
    zIndex: 2,
  },
  menu: {
    zIndex: 2,
    '&:hover': {
      cursor: 'pointer',
      color: '#8CB4FF',
    },
  },
  navMenu: {
    justifyContent: 'center !important',
    '&:hover': {
      cursor: 'default',
    },
  },
});

export default useSiteHeaderStyle;
